import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from './generic.service';

@Injectable({
  providedIn: 'root'
})
export class RetriveService extends GenericService {

  constructor(http: HttpClient) {
    super(http, 'retrive');
  }

  // Listar com filtros
  listar(filtros: any): Observable<any> {
    let params = new HttpParams();
    
    if (filtros.retrive_importacao_id) {
      params = params.set('retrive_importacao_id', filtros.retrive_importacao_id);
    }
    if (filtros.estacao_id) {
      params = params.set('estacao_id', filtros.estacao_id);
    }
    if (filtros.tipo_variavel_id) {
      params = params.set('tipo_variavel_id', filtros.tipo_variavel_id);
    }
    if (filtros.data_inicial) {
      params = params.set('data_inicial', filtros.data_inicial);
    }
    if (filtros.data_final) {
      params = params.set('data_final', filtros.data_final);
    }
    if (filtros.order_by) {
      params = params.set('order_by', filtros.order_by);
    }
    if (filtros.order_dir) {
      params = params.set('order_dir', filtros.order_dir);
    }
    if (filtros.per_page) {
      params = params.set('per_page', filtros.per_page);
    }
    if (filtros.page) {
      params = params.set('page', filtros.page);
    }

    return this.http.get(`${this.url_base}/${this.prefixo}`, { params });
  }

  // Consulta enxuta: ação de uma importação ou análise por estação/período
  consultar(filtros: {
    retrive_importacao_id?: number | null;
    estacao_id?: number | null;
    data_inicial?: string;
    data_final?: string;
    tipo_variavel_id?: number | number[];
    com_coleta?: boolean;
  }): Observable<any> {
    let params = new HttpParams();

    if (filtros.retrive_importacao_id) {
      params = params.set('retrive_importacao_id', String(filtros.retrive_importacao_id));
    }
    if (filtros.estacao_id) {
      params = params.set('estacao_id', String(filtros.estacao_id));
    }
    if (filtros.data_inicial) {
      params = params.set('data_inicial', filtros.data_inicial);
    }
    if (filtros.data_final) {
      params = params.set('data_final', filtros.data_final);
    }
    if (filtros.com_coleta) {
      params = params.set('com_coleta', '1');
    }

    const tipos = filtros.tipo_variavel_id;
    if (Array.isArray(tipos)) {
      tipos.forEach((id) => {
        params = params.append('tipo_variavel_id[]', String(id));
      });
    } else if (tipos) {
      params = params.set('tipo_variavel_id', String(tipos));
    }

    return this.http.get(`${this.url_base}/${this.prefixo}/consulta`, { params });
  }

  // Buscar retrives por estação e período
  buscarPorEstacaoPeriodo(estacaoId: number, dataInicial: string, dataFinal: string): Observable<any> {
    const params = new HttpParams()
      .set('estacao_id', estacaoId.toString())
      .set('data_inicial', dataInicial)
      .set('data_final', dataFinal);
    
    return this.http.get(`${this.url_base}/${this.prefixo}/estacao-periodo`, { params });
  }

}

